module.exports = __webpack_public_path__ + "static/media/left-arrow-page.d1356d45.svg";